<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'REVIEW_CANCEL_DIALOG_CANCEL'| translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>
<mat-dialog-content class="review-cancel-container">
    <div [formGroup]="costReviewCancelForm">
        <div class="row col-sm-12">
            <div class="col-sm-2 flex-align-center">
                <label>{{'REVIEW_CANCEL_DIALOG_REVIEWER'| translate}}</label>
            </div>
            <div class="col-sm-8">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <mat-select formControlName="reviewer" (selectionChange)="onReviewerChange($event)">
                        @if (assignedReviewers.length > 1) {
                            <mat-option [value]="ALL_REVIEWERS_VALUE">{{'REVIEW_CANCEL_DIALOG_ALL_REVIEWERS' | translate}}</mat-option>
                        }
                        @for (reviewer of assignedReviewers; track reviewer.reviewUserId) {
                            <mat-option [value]="reviewer.reviewUserId">{{getReviewerDisplayLabel(reviewer)}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-2 d-flex justify-content-end p-0">
                <button class="cancel-btn" [disabled]="isCancelDisabled" mat-button color="warn" (click)="onCancel()">{{'CANCEL_BTN_LABEL'| translate}}</button>
            </div>
        </div>
        <hr class="first-hr" />
        <div class="row row-height">
            <div class="col-sm-6">
                <label>{{'REVIEW_CANCEL_DIALOG_REPLACE_SELECTED_REVIEW'| translate}}</label>
            </div>
        </div>
        <div class="row col-sm-12 flex-align-center">
            <div class="col-sm-2">
                <label>{{'REVIEW_CANCEL_DIALOG_AVAILABLE'| translate}}</label>
            </div>
            <div class="col-sm-8">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <mat-select formControlName="available" (selectionChange)="onAvailableReviewerChange($event)" [disabled]="isAvailableReviewerDisabled">
                        <mat-option class="optionHeight"
                            *ngFor="let role of availableReviewers; trackBy: trackByReviewerId"
                            [value]="role.reviewUserId">{{role.reviewerName}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <hr class="second-hr" />
        <div class="row col-sm-12 flex-align-center">
            <div class="col-sm-2">
                <label>{{'REVIEW_CANCEL_DIALOG_ROLE'| translate}}</label>
            </div>
            <div class="col-sm-8">
                <mat-form-field appearance="outline" class="col-sm-12">
                    @if (isSelectedReviewerPolicyMandated) {
                        <input matInput [value]="selectedAssignedReviewerRoleDescription" readonly>
                    }
                    @else {
                        <mat-select formControlName="role">
                            <mat-option class="optionHeight" *ngFor="let role of visibleReviewerRoles; trackBy: trackByRoleId"
                                [value]="role.id">{{role.description}}</mat-option>
                        </mat-select>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="row col-sm-12 flex-align-center">
            <div class="col-sm-2">
                <label>{{'REVIEW_CANCEL_DIALOG_NAME'| translate}}</label>
            </div>
            <div class="col-sm-8">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <input matInput formControlName="name">
                </mat-form-field>
            </div>
        </div>
        <div class="row col-sm-12 row-height">
            <div class="col-sm-2 flex-align-center">
                <label>{{'REVIEW_CANCEL_DIALOG_EMAIL'| translate}}</label>
            </div>
            <div class="col-sm-8 email-verify-wrapper">
                <mat-form-field appearance="outline" class="email-input-field">
                    <input matInput formControlName="email">
                </mat-form-field>
                <button class="flex-align-center" mat-button color="primary" (click)="onVerifyClick()" [disabled]="isVerifyDisabled">{{'VERIFY_BTN_LABEL' | translate}}</button>
            </div>
        </div>
        <div class="row col-sm-12 flex-align-center">
            <div class="col-sm-2">
                <label>{{'REVIEW_CANCEL_DIALOG_REQUIRED_BY'| translate}}</label>
            </div>
            <div class="col-sm-4 flex-align-center">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <input matInput [matDatepicker]="requiredByDate" formControlName="requiredByDate"
                    [min]="minDate" placeholder="{{'SELECT_DATE' | translate}}">
                    <mat-datepicker-toggle matSuffix
                        [for]="requiredByDate" [disabled]="isAllReviewersSelected"></mat-datepicker-toggle>
                    <mat-datepicker #requiredByDate></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row col-sm-12">
            <div class="col-sm-10 d-flex flex-column">
                <label>{{'REVIEW_CANCEL_DIALOG_REPORT_ADD_EMAIL_NOTE'| translate}}</label>
                <mat-form-field appearance="outline">
                    <textarea class="email-textarea" matInput rows="4" formControlName="emailNote">
                    </textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="fieldset-wrapper"> 
            <mat-radio-group formControlName="requestType" (change)="onRequestTypeChange($event)">
                <mat-radio-button class="pl-10" color="primary" value="0">
                    {{'REVIEW_CANCEL_DIALOG_REPORT_SEND_REQUEST_OPEN_EMAIL' | translate}}
                </mat-radio-button>
            <fieldset>
                <legend>
                    <mat-radio-button color="primary" value="1">
                        {{'REVIEW_CANCEL_DIALOG_REPORT_SEND_REQUEST_AUTO' | translate}}
                    </mat-radio-button>
                </legend>
                <div>
                    <div class="row row-height col-sm-12 flex-align-center">
                        <label class="col-sm-2 d-flex align-items-center">{{'REVIEW_CANCEL_DIALOG_REPORT_1' | translate}}</label>
                        <div class="col-sm-8">
                            <app-multi-pdf-report-dropdown class="col-sm-12"
                                [reportsList]="reportsList"
                                [control]="costReviewCancelForm.controls.report1"
                                [showEmptyOption]="true">
                            </app-multi-pdf-report-dropdown>
                        </div>
                    </div>
                    <div class="row row-height col-sm-12 flex-align-center">
                        <label class="col-sm-2 d-flex align-items-center">{{'REVIEW_CANCEL_DIALOG_REPORT_2' | translate}}</label>
                        <div class="col-sm-8">
                            <app-multi-pdf-report-dropdown class="col-sm-12"
                                [reportsList]="reportsList"
                                [control]="costReviewCancelForm.controls.report2"
                                [showEmptyOption]="true">
                            </app-multi-pdf-report-dropdown>
                        </div>
                    </div>
                    <div class="row row-height col-sm-12 flex-align-center">
                        <label class="col-sm-2 d-flex align-items-center">{{'REVIEW_CANCEL_DIALOG_REPORT_3' | translate}}</label>
                        <div class="col-sm-8">
                            <app-multi-pdf-report-dropdown class="col-sm-12"
                                [reportsList]="reportsList"
                                [control]="costReviewCancelForm.controls.report3"
                                [showEmptyOption]="true">
                            </app-multi-pdf-report-dropdown>
                        </div>
                    </div>
                </div>
            </fieldset>
            </mat-radio-group>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="replace-cancel-btn" align="end">
    <button mat-button color="primary" (click)="onSend()"
        [disabled]="isSendDisabled">{{'REPLACE_BTN_LABEL' | translate}}</button>
    <button mat-button color="warn" mat-dialog-close>{{'CANCEL_BTN_LABEL' | translate}}</button>
</mat-dialog-actions>